module.exports = __webpack_public_path__ + "img/ge.d0fb6089.svg";